module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKBU_AESC.9fe593e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKBU_AESC.png
// module id = 55
// module chunks = 0